import React from 'react';
import './ConfirmationDialog.css'

export default function ConfirmationDialog({ title, description, onCancelClick, onSubmitClick, submitButtonText, cancelButtonText }) {

    return (
        <>
            <div className="dialog-mask"></div>
            <div className="dialog-container">
                <div className="dialog-box">
                    <h3 className="title">{title}</h3>
                    <p className="description">{description}</p>
                    <div className="button-row">
                        {cancelButtonText && 
                            <button type="button" className="cancel" onClick={onCancelClick}>{cancelButtonText}</button>
                        }
                        
                        <button type="button" className="submit" onClick={onSubmitClick}>{submitButtonText}</button>
                    </div>
                </div>
            </div>
        </>
    )
}